export const Loader = ({ label = "Loading dashboard…" }) => {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-background">
            <div className="relative h-14 w-14">
                <span className="absolute inset-0 rounded-full border-2 border-primary/20" />
                <span className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-primary" />
                <span className="absolute inset-[6px] rounded-full bg-primary/10" />
            </div>
            <p className="font-serif-elegant text-lg text-muted-foreground">{label}</p>
        </div>
    );
};
